import { Checkbox, FormControlLabel } from '@mui/material';

import type { CrisisPlanNotNeededCheckboxProps } from './types';

export default function CrisisPlanNotNeededCheckbox({
  checked,
  disabled = false,
  onChange,
}: CrisisPlanNotNeededCheckboxProps) {
  return (
    <FormControlLabel
      sx={{ alignSelf: 'flex-start' }}
      control={
        <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={(_event, value) => onChange(value)}
        />
      }
      label="Crisis plan for this client not needed"
    />
  );
}
